import theme from "@/styles/theme";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import {ButtonGroup, IconButton} from "@mui/material";
import {grey} from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useRouter} from "next/router";
import {useContext} from "react";
import AppContext from "@/context/AppContext";
import {basierCirleBold} from "@/styles/fonts";


export const BandMembers = ({members, displayPending = false}) => {
    const router = useRouter();
    const {isAuthenticated} = useContext(AppContext);

    return (
        <>
            <Grid container alignItems="center" spacing={{sm: 1}}>
                {members?.filter(m => displayPending === true || m.pending === false)?.map((member) => {
                    return (
                        <Grid key={member.id} item xs={12}>
                            <Grid container columnSpacing={1} justifyContent="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Grid container alignItems="center">
                                        <Grid item xs="auto">
                                            {member.user_profile.user?.id && (
                                                <ButtonGroup variant="contained">
                                                    <IconButton
                                                        disabled={!isAuthenticated}
                                                        size="small"
                                                        color="secondary"
                                                        aria-label="Nachricht senden"
                                                        title="Nachricht senden"
                                                        sx={{
                                                            "&.MuiButtonBase-root": {
                                                                minWidth: "1.25rem",
                                                                marginRight: "0.5rem",
                                                                "&.Mui-disabled": {
                                                                    backgroundColor: "grey !important",
                                                                },
                                                            },
                                                        }}
                                                        onClick={() => {
                                                            router.push(`/secure/chat/new?profile=${member.user_profile.id}`)
                                                        }}
                                                    >
                                                        <ChatBubbleIcon fontSize="small"/>
                                                    </IconButton>
                                                </ButtonGroup>
                                            )}
                                        </Grid>
                                        <Grid item xs="auto">
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    fontFamily: basierCirleBold.style.fontFamily,
                                                    fontWeight: basierCirleBold.style.fontWeight,
                                                }}
                                            >
                                                {member.user_profile?.name.slice(0, 24)}{member.user_profile?.name.length > 23 && '...'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid
                                    key={member.id}
                                    item
                                    xs={12}
                                    sm="auto"
                                    sx={{
                                        maxWidth: "100% !important",
                                        textTransform: "uppercase",
                                        color: grey[500],
                                        [theme.breakpoints.up("sm")]: {
                                            textAlign: "right",
                                        },
                                        "& span:not(:last-of-type)": {
                                            "&::after": {
                                                content: "', '",
                                            },
                                        },
                                    }}
                                >
                                    <span>
                                        {member.musical_instruments[0]?.name} {member.musical_instruments?.length > 1 && (<> + {(member.musical_instruments?.length - 1)} </>)}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
};
